import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader } from '@chakra-ui/react';
import { Dec } from '@terra-money/terra.js';
import { ConnectType, useWallet } from '@terra-money/wallet-provider';
import { ethers } from 'ethers';
import { DeviceType, deviceType } from "functions/deviceType";
import { toChainAmount } from "functions/toXAmount";
import WindowDimensions from "hooks/useDimensions";
import { setBalance, setChainAddress } from "state/global";
import { ProviderWindow } from "types/types";
import st_wallet from "./WalletButton.module.css";

enum Wallet {
  METAMASK = 0,
  BINANCE = 1,
}

declare var window: ProviderWindow;

const ConnectModal = ({ open, setOpen }: any) => {
  const { connect, availableConnections } = useWallet();
  const isWeb = WindowDimensions();

  const connectEthProvider = async (walletType: Partial<Wallet>) => {
    setOpen(false);

    if (window.xfi?.ethereum!.isMetaMask) {
      alert("Please de-prioritize XDEFI Wallet and reload the page");
      return;
    }

    try {
      let provider: any;

      if (walletType === Wallet.METAMASK) {
        if (deviceType() !== DeviceType.DESKTOP && !window.ethereum) {
          alert("Please use browser inside MetaMask App to connect");
          return;
        }

        provider = new ethers.providers.Web3Provider(window.ethereum!, "any");
      } else {
        provider = new ethers.providers.Web3Provider(
          window.BinanceChain!,
          "any"
        );
      }

      // Prompt user for account connections
      await provider.send("eth_requestAccounts", []);
      const network = await provider.getNetwork();
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      const wei_balance = await signer.getBalance();
      const eth_balance = new Dec(parseInt(wei_balance.toHexString(), 16))
        .div(1e18)
        .toNumber();

      if (walletType === Wallet.METAMASK) {
        setBalance("eth", toChainAmount(eth_balance));
      } else {
        setBalance("bnb", toChainAmount(eth_balance));
      }

      setChainAddress("address", address);
      setChainAddress("network", network.name);
    } catch (e: any) {
      if (e.message.includes("rejected")) {
        return;
      } else if (e.message.includes("missing provider")) {
        isWeb && alert("Please install this wallet and try again");
        !isWeb && alert(e.message);
      } else {
        alert(e.message);
      }
    }
  };

  const connectWithTerraProvider = () => {
    setOpen(false);
    isWeb ? connect() : connect(ConnectType.WALLETCONNECT);
  };

  const connectAtomProvider = () => {
    window.keplr.enable(["cosmoshub-4"]);

    // console.log(window.keplr.)
  };

  const connectSafePal = async () => {
    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(
        window.ethereum!,
        "any"
      );

      await provider.send("eth_requestAccounts", []);
      const network = await provider.getNetwork();
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      const wei_balance = await signer.getBalance();
      const balance = new Dec(parseInt(wei_balance.toHexString(), 16))
        .div(1e18)
        .toNumber();

      if (network.name.includes("bnb")) {
        setBalance("bnb", toChainAmount(balance));
      } else {
        setBalance("eth", toChainAmount(balance));
      }

      setChainAddress("address", address);
      setChainAddress("network", network.name);
    } else {
      connect(ConnectType.EXTENSION, "SafePal");
    }
    setOpen(false);
  };

  const isSafePal =
    (deviceType() !== DeviceType.DESKTOP && window.ethereum) ||
    availableConnections.some(
      (connection) => connection.identifier === "SafePal"
    );

  return (
    <Modal isCentered isOpen={open} onClose={() => null} size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton onClick={() => setOpen(false)} />
        <div className={st_wallet.connect_modal}>
          <ModalHeader>Connect to a Wallet</ModalHeader>
          <div className={st_wallet.wallet} onClick={connectWithTerraProvider}>
            <img src="/images/icons/svg/Terra.svg" />
            {isWeb ? "Terra Provider or xDefi" : "Wallet Connect"}
          </div>
          <div
            className={`${st_wallet.wallet} ${st_wallet.meta}`}
            onClick={() => connectEthProvider(Wallet.METAMASK)}
          >
            <img src="/images/icons/png/metamask.png" />
            Metamask
          </div>
          {isWeb && (
            <div
              className={`${st_wallet.wallet} ${st_wallet.binance}`}
              onClick={() => connectEthProvider(Wallet.BINANCE)}
            >
              <img src="/images/icons/png/binance.png" />
              Binance Wallet
            </div>
          )}
          {isSafePal && (
            <button
              className={`${st_wallet.wallet} ${st_wallet.safepal}`}
              onClick={connectSafePal}
            >
              <img src="/images/icons/png/safepal.png" />
              SafePal
            </button>
          )}
          {/* <button 
                    className={st_wallet.meta} 
                    onClick={ connectAtomProvider }>
                        Keplr Wallet
                    </button> */}
        </div>
      </ModalContent>
    </Modal>
  );
};

export default ConnectModal;